import PrimaryButton from "@/components/UI/PrimaryButton";
import TimerButton from "@/components/UI/TimerButton";
import InfoBar from "@/components/UI/InfoBar";

export default [
    PrimaryButton,
    TimerButton,
    InfoBar
]